import React from 'react';
import PropTypes from 'prop-types';

import { SortableContainer } from 'react-sortable-hoc';

// Components
import RsvpListItemV2 from './RsvpListItemV2';

const RsvpsList = SortableContainer(({ orderedIds, rsvpEntities, onEdit, updateEvent }) => {
  return (
    <ul className="rsvps-list sortable-list edit-page-entities-list">
      {orderedIds.map((rsvptId, index) => (
        <RsvpListItemV2
          rsvp={rsvpEntities[rsvptId]}
          key={rsvptId}
          index={index}
          onEdit={onEdit}
          updateEvent={updateEvent}
        />
      ))}
    </ul>
  );
});

RsvpsList.propTypes = {
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  rsvpEntities: PropTypes.shape({}),
  onEdit: PropTypes.func,
  onSortEnd: PropTypes.func,
  updateEvent: PropTypes.func,
};

export default RsvpsList;
